import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Home from "./components/Home/Home";
import SignIn from "./components/Login/SignIn";
import Signup from "./components/Signup/Signup";
import NotFound from "./components/NotFound/NotFound";
import Footer from "./components/Shared/Footer";
import Profile from "./components/Profile.js/Profile";
import EditProfile from "./components/Profile.js/EditProfile";
import NewPost from "./components/NewPost/NewPost";
import Feed from "./components/Feed/Feed";
import Offers from "./components/Offers/Offers";
import SinglePost from "./components/Feed/SinglePost";
import Dashboard from "./components/Dashboard/Dashboard";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import AdminRole from "./components/Dashboard/AdminRole";
import PostDetails from "./components/Feed/PostDetails";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/login" element={<SignIn />}></Route>
        <Route path="/signup" element={<Signup />}></Route>
        <Route path="/u/:id" element={<Profile />}></Route>
        <Route path="/editprofile" element={
          <PrivateRoute>
            <EditProfile />
          </PrivateRoute>
        }></Route>
        <Route path="/feed" element={<Feed />}></Route>
        <Route path="/post/:id" element={<SinglePost />}></Route>
        <Route path="/newpost/:id" element={
          <PrivateRoute>
            <NewPost />
          </PrivateRoute>
        }></Route>
        <Route path="/details/:id" element={
          <PrivateRoute>
            <PostDetails />
          </PrivateRoute>
        }></Route>
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }></Route>
        <Route path="/changerole" element={
          <PrivateRoute>
            <AdminRole />
          </PrivateRoute>
        }></Route>
        <Route path="/offers" element={<Offers />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default App;
